import Vue from 'vue';
import Router from 'vue-router';
import { Role } from './helpers/role.js';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            meta: {
              requiresAuth: true
            },
            children: [
                /********************************************************************/
                {
                    path: '/',
                    name: 'home',
                    component: () => import('./views/pages/home/Home.vue')
                }, 
                /********************************************************************/
                {
                    path: '/geolocalizacion',
                    name: 'geolocalizacion',
                    component: () => import('./views/pages/geo/GeoLocalizacion.vue')
                }, 
                /********************************************************************/
                {
                    path: '/monitoreo/diario/meta',
                    name: 'monitoreo-diario-meta',
                    component: () => import('@/views/pages/monitoreo/MainMeta.vue'),
                    children: [
                        {
                            path: '',
                            name: 'monitoreo-diario-meta',
                            component: () => import('./views/pages/monitoreo/meta/Meta.vue'),
                            meta: {
                                breadcrumb: [
                                    { title: 'Inicio', url: '/' },
                                    { title: 'Metas y/o Proyectos', active: true }
                                ],
                                pageTitle: 'Monitoreo de actividades',
                                no_scroll: true,
                                parent: 'monitoreo-diario-meta',
                                authorize: [Role.Admin, Role.Coord]
                            }
                        }, {
                            path: '/monitoreo/diario/meta/detalle/:id',
                            name: 'monitoreo-diario-meta-detalle',
                            component: () => import('./views/pages/monitoreo/meta/ReporteDiario.vue'),
                            meta: {
                                breadcrumb: [
                                    { title: 'Inicio', url: '/' },
                                    { title: 'Metas y/o Proyectos', url: '/monitoreo/diario/meta' },
                                    { title: 'Reporte Diario', active: true }
                                ],
                                pageTitle: 'Monitoreo de actividades',
                                parent: 'monitoreo-diario-meta',
                                authorize: [Role.Admin, Role.Coord]
                            },
                        }
                    ]
                },    
                {
                    path: '/monitoreo/diario/localizacion',
                    name: 'monitoreo-diario-localizacion',
                    component: () => import('@/views/pages/monitoreo/Localizacion.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Localicacion de Personal', active: true }
                        ],
                        pageTitle: 'Monitoreo de actividades',
                        parent: 'monitoreo-diario-localizacion',
                        authorize: [Role.Admin, Role.Coord]
                    }
                }, 
                {
                    path: '/monitoreo/diario/semaforo',
                    name: 'monitoreo-diario-semaforo',
                    component: () => import('@/views/pages/monitoreo/Semaforo.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Semafóro', active: true }
                        ],
                        pageTitle: 'Monitoreo de actividades',
                        parent: 'monitoreo-diario-semaforo',
                        authorize: [Role.Admin, Role.Coord]
                    }
                }, 
                /********************************************************************/

                /********************************************************************/
                {
                    path: '/perfil/cuenta',
                    name: 'perfil-cuenta',
                    component: () => import('@/views/pages/cuenta/Perfil.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Cuenta', active: true }
                        ],
                        pageTitle: 'Mi Perfil',
                        parent: 'perfil-cuenta',
                        authorize: [Role.Admin, Role.Coord, Role.User]
                    }
                },
                {
                    path: '/perfil/cambio',
                    name: 'perfil-cambio',
                    component: () => import('@/views/pages/cuenta/Cambio.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Cambio de Contraseña', active: true }
                        ],
                        pageTitle: 'Mi Perfil',
                        parent: 'perfil-cambio',
                        authorize: [Role.Admin, Role.Coord, Role.User]
                    }
                },
                /********************************************************************/
                {
                    path: '/app/parametro/meta',
                    name: 'app-parametro-meta',
                    component: () => import('@/views/pages/admin/Meta.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Metas', active: true }
                        ],
                        pageTitle: 'Mantenimiento de parámetros',
                        parent: 'app-parametro-meta',
                        authorize: [Role.Admin, Role.Coord]
                    }
                }, 
                {
                    path: '/app/parametro/proyecto',
                    name: 'app-parametro-proyecto',
                    component: () => import('@/views/pages/admin/MainProyecto.vue'),
                    children: [
                        {
                            path: '',
                            name: 'app-parametro-proyecto',
                            component: () => import('@/views/pages/admin/components/Proyecto.vue'),
                            meta: {
                                breadcrumb: [
                                    { title: 'Inicio', url: '/' },
                                    { title: 'Proyectos de Inversión', active: true }
                                ],
                                pageTitle: 'Mantenimiento de parámetros',
                                no_scroll: true,
                                parent: 'app-parametro-proyecto',
                                authorize: [Role.Admin, Role.Coord]
                            }
                        }, {
                            path: '/app/parametro/proyecto/detalle/:id',
                            name: 'app-parametro-proyecto-detalle',
                            component: () => import('@/views/pages/admin/components/ProyectoDetalle.vue'),
                            meta: {
                                breadcrumb: [
                                    { title: 'Inicio', url: '/' },
                                    { title: 'Proyectos de Inversión', url: '/app/parametro/proyecto' },
                                    { title: 'Datos formato 12B y Ubicación', active: true }
                                ],
                                pageTitle: 'Mantenimiento de parámetros',
                                parent: 'app-parametro-proyecto',
                                authorize: [Role.Admin, Role.Coord]
                            },
                        }, {
                            path: '/app/parametro/proyecto/ubicacion/:id',
                            name: 'app-parametro-proyecto-ubicacion',
                            component: () => import('@/views/pages/admin/components/ProyectoUbicacion.vue'),
                            meta: {
                                breadcrumb: [
                                    { title: 'Inicio', url: '/' },
                                    { title: 'Proyectos de Inversión', url: '/app/parametro/proyecto' },
                                    { title: 'Ubicación del PIP', active: true }
                                ],
                                pageTitle: 'Mantenimiento de parámetros',
                                parent: 'app-parametro-proyecto',
                                authorize: [Role.Admin, Role.Coord]
                            },
                        }, {
                            path: '/app/parametro/proyecto/estados/:id',
                            name: 'app-parametro-proyecto-estados',
                            component: () => import('@/views/pages/admin/components/ProyectoEstados.vue'),
                            meta: {
                                breadcrumb: [
                                    { title: 'Inicio', url: '/' },
                                    { title: 'Proyectos de Inversión', url: '/app/parametro/proyecto' },
                                    { title: 'Estado del PIP', active: true }
                                ],
                                pageTitle: 'Mantenimiento de parámetros',
                                parent: 'app-parametro-proyecto',
                                authorize: [Role.Admin, Role.Coord]
                            },
                        }
                    ]
                }, 
                {
                    path: '/app/parametro/cargo',
                    name: 'app-parametro-cargo',
                    component: () => import('@/views/pages/admin/Cargo.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Cargos', active: true }
                        ],
                        pageTitle: 'Mantenimiento de parámetros',
                        parent: 'app-parametro-cargo',
                        authorize: [Role.Admin, Role.Coord]
                    }
                }, 
                /********************************************************************/
                {
                    path: '/usuario/acceso/personal',
                    name: 'usuario-acceso-personal',
                    component: () => import('@/views/pages/acceso/MainPersonal.vue'),
                    children: [
                        {
                            path: '',
                            name: 'usuario-acceso-personal',
                            component: () => import('./views/pages/acceso/Personal.vue'),
                            meta: {
                                breadcrumb: [
                                    { title: 'Inicio', url: '/' },
                                    { title: 'Persona', active: true }
                                ],
                                pageTitle: 'Usuarios y Acceso',
                                no_scroll: true,
                                parent: 'usuario-acceso-personal',
                                authorize: [Role.Admin, Role.Coord]
                            }
                        }, {
                            path: '/usuario/acceso/personal/detalle/:id',
                            name: 'usuario-acceso-personal-detalle',
                            component: () => import('./views/pages/acceso/DetallePersonal.vue'),
                            meta: {
                                breadcrumb: [
                                    { title: 'Inicio', url: '/' },
                                    { title: 'Usuarios y Acceso', url: '/usuario/acceso/personal' },
                                    { title: 'Detalle', active: true }
                                ],
                                pageTitle: 'Usuarios y Acceso',
                                parent: 'usuario-acceso-personal',
                                authorize: [Role.Admin, Role.Coord]
                            },
                        }
                    ]
                }, 
                {
                    path: '/usuario/acceso/asignacion',
                    name: 'usuario-acceso-asignacion',
                    component: () => import('@/views/pages/acceso/Asignacion.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Asignación de Metas/Proyectos a personal', active: true }
                        ],
                        pageTitle: 'Usuarios y Acceso',
                        parent: 'usuario-acceso-asignacion',
                        authorize: [Role.Admin, Role.Coord]
                    }
                }, 
                {
                    path: '/usuario/acceso/reset',
                    name: 'usuario-acceso-reset',
                    component: () => import('@/views/pages/acceso/Reset.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Resetear clave del usuario', active: true }
                        ],
                        pageTitle: 'Usuarios y Acceso',
                        parent: 'usuario-acceso-reset',
                        authorize: [Role.Admin, Role.Coord]
                    }
                },
                /********************************************************************/
                {
                    path: '/configuracion/ejecutora',
                    name: 'configuracion-ejecutora',
                    component: () => import('@/views/pages/configuracion/UnidadEjecutora.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Unidade Ejecutora', active: true }
                        ],
                        pageTitle: 'Configuracion',
                        parent: 'configuracion-ejecutora',
                        authorize: [Role.Admin]
                    }
                }
                /********************************************************************/
            ],
        }, {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            meta: {
              requiresVisitor: true
            },
            children: [
              {
                path: '/pages/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              }, {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              }, {
                path: '/pages/politicas/privacidad',
                name: 'page-politicas-privacidad',
                component: () => import('@/views/pages/PoliticasPrivacidad.vue')
              },
            ]
        }, {
            path: '*',
            redirect: '/'
        }
    ],
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
